import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  /* width: 80%; */
  color: #000;
  /* margin: 0 auto 10px; */
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: ${props => props.space? 'space-between': 'center'};
`;

export const Text = styled.p`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 40px;
  background-color: #C8C8C8;
  border-radius: 5px;
  padding: 25px;
`;

export const Sentence = styled.div`
  background-color: #333;
  text-align: center;
  color: #fff;
  width: 120px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-weight: bold;
  margin: 10px 0;
  
  span{
    font-size: 36px;
  }
`;
